import { AutocompleteField } from '@src/corelib/forms/generic';
import { useAbsenceTypes } from '@src/query';

type AbsenceType = {
  id: number;
  acty_name: string;
};

export default function ReasonField() {
  const { data } = useAbsenceTypes() as { data?: AbsenceType[] };
  const options = Array.isArray(data)
    ? data.map((item: AbsenceType) => ({
        label: item.acty_name,
        value: item.id,
      }))
    : [];
  return (
    <AutocompleteField
      label="Reason"
      name="typeId"
      sx={StyleSheet.reason}
      options={options}
    />
  );
}
const StyleSheet = {
  reason: {
    '.MuiFormLabel-root': {
      top: '20px',
    },
  },
};
